import { safeDefine } from '@breuni-ui/safe-define';

export default class AnchorLinkElement extends HTMLElement {
  connectedCallback() {
    this.click = () => {
      const element = document.getElementById(this.getAttribute('target-id'));
      const padding = parseInt(this.getAttribute('padding') || '0', 10);

      if (element) {
        const elementY = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: elementY - padding,
          behavior: 'smooth',
        });
      }

      element.focus({ preventScroll: true });
    };

    this.addEventListener('click', this.click);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.click);
  }
}

safeDefine('bewerten-anchor-link', AnchorLinkElement);
